export default __webpack_public_path__ + "static/media/wa-1716.8e1e9767.jpg";